import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  changeCurrentMemberMenu,
  changeisNavigationFromEventToMember,
  // screenChange
} from "../../store/screenSlice";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { screenConfig } from "../../config/screenConfig";
import {
  updateEvent,
  deleteCostInfo,
  deleteLocationInfo,
} from "../../store/eventApiSlice";
import { DevTool } from "@hookform/devtools";
import CurrencyInput from "react-currency-input-field";
import deleteIcon from "./../../Images/Delete.png";
import {
  useForm,
  Controller,
  useFormContext,
  Merge,
  FieldError,
  FieldErrorsImpl,
} from "react-hook-form";
import {
  Button,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import { DateValidationError } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { all } from "axios";
import { invalid } from "moment";
import ReactModal from "react-modal";
import MemberServices from "../../services/MemberServices";
import EventServices from "../../services/EventServices";
import OrderServices from "../../services/OrderServices";
import moment from "moment";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import * as routeConfig from "../../config/routes";
import EventMemberPaymentInfo from "../Events/EventMemberPaymentInfo";
import {
  IOrder,
  resetOrderParameters,
  setCurrentOrderId,
  storeUpdateOrder,
  assignOrderInfo,
  storeAssignOrderItem,
  storeUpdateOrderItem,
} from "../../store/orderApiSlice";
import { storeResetGuestOrder } from "../../store/guestOrderApiSlice";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { IPaymentInfo } from "../../store/memberInterfaceStruct";
interface ILocation {
  Id: number | null;
  OrderId: number | null;
  SeminarOrderItemId: number | null;
  FunctionOrderItemId: number | null;
  LocationId: number | null;
  EventId: number | null;
  Status: number | null;
  CreatedAt: String | null;
  Location: String | null;
  Cost: number | null;
}

interface ICost {
  Id: number | null;
  OrderId: number | null;
  SeminarOrderItemId: number | null;
  FunctionOrderItemId: number | null;
  CostId: number | null;
  EventId: number | null;
  Status: number | null;
  CreatedAt: String | null;
  CostName: String | null;
  Cost: number | null;
}

interface IVideoCost {
  CostName: string | null;
  Cost: number | null;
}

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
  SectionOrderId: number;
}

interface IMemberShipOrder {
  Id: number | null;
  OrderId: number | null;
  MemberId: number | null;
  MemberCodeId: number | null;
  LastYearSections: String | null;
  CurrentYearSections: String | null;
  Description: String | null;
  Fee: number | null;
  MemberCode: String | null;
}

interface IVideoOrder {
  Id: number | null;
  OrderId: number | null;
  EventId: number | null;
  MemberId: number | null;
  IsCompleted: number | null;
  CompletionPercentage: number | null;
  CreatedAt: String | null;
  VideoCost: IVideoCost[] | null;
  EventName: String | null;
  Description: String | null;
  UniqueEventId: String | null;
  StartDateTime: String | null;
  EndDateTime: String | null;
  Costs: ICost[] | [];
}

interface ISeminarOrder {
  Id: number | null;
  OrderId: number | null;
  EventId: number | null;
  MemberId: number | null;
  ParticipantType: String | null;
  isAttended: number | null;
  CreatedAt: String | null;
  OrderItemId: number | null;

  EventName: String | null;
  Description: String | null;
  UniqueEventId: String | null;
  StartDateTime: String | null;
  EndDateTime: String | null;
  CostVariationTotalCost: number | null;
  EventVariationTotalCost: number | null;
  Location: ILocation | null;
  Costs: ICost[] | [];
}

interface IOrderInfo {
  MemberId: number | null;
  OrderId: number | null;
  TransactionType: String | null;
  TotalAmount: number | null;
  AmountPaid: number | null;
  DatePaid: String | null;
  CheckNumber: String | null;
  LateFee: String | null;
  AuthCode: String | null;
  SeminarOrder: ISeminarOrder[] | [];
  FunctionOrder: ISeminarOrder[] | [];
  SectionOrder: ISection[] | [];
  MemberShipOrder: IMemberShipOrder[] | [];
  VideoOrder: IVideoOrder[] | [];
  OrderStatus: number | null;
  CreatedAt: String | null;
  StatusName: String | null;
  Comments : String | null;
  FirstName: String | null;
  CouponAmount : number | null;
  LastName: String | null;
  AdmitDate: String | null;
  MemberCodeId: number | null;
  BarId: String | null;
  MemberCode: String | null;
  MemberCodeDescription: String | null;
  FirmName: String | null;
  Address1: String | null;
  Address2: String | null;
  City: String | null;
  County: String | null;
  State: String | null;
  Zipcode: String | null;
  PhoneNumber: String | null;
  FaxNumber: String | null;
  Email: String | null;
  NoInvoice: boolean | null;
  FirmAdminName: String | null;
  FirmAdminPhoneNumber: String | null;
  FirmAdminEmailId: String | null;
  TransactionDoneBy: number | null;
  TransactionDoneByName: String | null;
}

const ViewOrder: React.FC = () => {


    const formPaymentInfo = useForm<IPaymentInfo>();
    const {
      register: registerPI,
      control: controlPI,
      handleSubmit: handleSubmitPI,
      formState: formStatePI,
      setValue: setValuePI,
      clearErrors: clearErrorsPI,
    } = formPaymentInfo;

  console.log("ViewOrder");
  const dispatch = useDispatch();
  const currentOrderId = useSelector(
    (state: RootState) => state.orderapislice.CurrentOrderId
  );
  console.log(currentOrderId);
  const orderInfo: IOrder = useAppSelector((store) => store.orderapislice);
  const navigate = useNavigate();
  const color1 = "#2d6289";
  const textColor = "#25284e";

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );
  const [isLoading, setIsLoading] = useState(false);
  const [addEditOrderOpen, setEditOrderOpen] = useState(false);
  const [PIModalOpen, setPIModalOpen] = useState(false);
  const [orderInfoSetFlag, setOrderInfoSetFlag] = useState<boolean>(false);
  useEffect(() => {
    console.log("useEffect orderInfo:", orderInfo);
    setOrderInfoSetFlag(true);
  }, [orderInfo]);

  const [orderinfo, setOrderInfo] = useState<IOrderInfo>();
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const formatPhoneNumber = (input: any) => {
    if (input == null) {
      return null;
    } else {
      // Remove all non-digit characters
      let numericInputFormatted = input.replace(/\D/g, "");

      // Apply formatting based on length
      if (numericInputFormatted.length > 6) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{3})(\d{0,4})/,
          "($1) $2-$3"
        );
      } else if (numericInputFormatted.length > 3) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{0,3})/,
          "($1) $2"
        );
      } else if (numericInputFormatted.length > 1) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{0,3})/,
          "($1"
        );
      }

      return numericInputFormatted.trim();
    }
  };
    const [isSubmitPaymentInfoLoading, setIsSubmitPaymentInfoLoading] =
      useState<boolean>(false);

  let address: string[] = [];
  orderinfo && orderinfo?.Address1 && address.push(`${orderinfo.Address1}, `);
  orderinfo && orderinfo?.Address2 && address.push(`${orderinfo?.Address2}, `);
  orderinfo && orderinfo?.City && address.push(`${orderinfo?.City}, `);
  orderinfo && orderinfo?.County && address.push(`${orderinfo?.County}, `);
  orderinfo && orderinfo?.State && address.push(`${orderinfo?.State} `);
  orderinfo && orderinfo?.Zipcode && address.push(orderinfo?.Zipcode as string);

  // const muiTextFieldTheme
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              // borderBottomStyle: "solid",
              // borderBottomWidth: 1,
              boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
              paddingTop: "20px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "0px",
              fontWeight: "400",
              "&.Mui-disabled": {
                WebkitTextFillColor: textColor,
              },
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              "&.Mui-disabled": {
                color: color1,
              },
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              // marginBottom: "1.8rem",
            },
          },
        },
      },
    });
    const [TransactionType, setTransactionType] = useState<string>("");
    const [datePaid, setDatePaid] = useState<any>(null);

    const checkRequiredFields = () => {
      let missingFields: string = "Required Fields Missing: ";
      if (orderinfo?.TransactionType == "") {
        missingFields = missingFields + "TransactionType, ";
      }
      if (orderinfo?.DatePaid == null || !orderinfo?.DatePaid) {
        console.log("Data missing");
        missingFields = missingFields + "Date Paid, ";
      }
      if (missingFields !== "Required Fields Missing: ") {
        console.log("missingFields1:", missingFields);
        alert(missingFields);
        return true;
      } else {
        console.log("No missing field");
        return false;
      }
    };

  useEffect(() => {
    console.log("useEffect", currentOrderId);
    setIsLoading(true);
    const getOrderList = async (currentOrderId: number) => {
      const response = await OrderServices.getOrder(currentOrderId);
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success:", response.data.data);
        setOrderInfo(response.data.data);
        setIsLoading(false);
        // dispatch(updateEventList(response.data.data));
      } else {
        setIsLoading(false);
      }
    };

    getOrderList(currentOrderId as number);
  }, []);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [couponAmount, setCouponAmount] = useState<number>(0);
  const [AmountPaid, setAmountPaid] = useState<number>(0);

  const checkIsAmountPaidEntered = () => {
    if ((orderinfo?.TotalAmount??0) === 0 || (orderinfo?.CouponAmount ?? 0) > 0 || (orderinfo?.AmountPaid ?? 0) > 0) {
      return false;
    } else {
      alert("Please enter Amount");
      return true;
    }
  };

  const checkIsAmountPaid = () => {
    if ((orderinfo?.TotalAmount??0) > (Number(orderinfo?.AmountPaid??0) + Number(orderinfo?.CouponAmount??0))) {
      const userResponse = window.confirm(
        "Amount Paid is less than Billed Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    } else if ((orderinfo?.TotalAmount??0) < (Number(orderinfo?.AmountPaid??0) + Number(orderinfo?.CouponAmount??0))) {
      const userResponse = window.confirm(
        "Amount Paid is more than Billed Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };
    const [receiptURL, setReceiptURL] = useState<string>("");
    const onSubmitPaymentInfo = async () => {
      setTimeout(async () => {
        if (isSubmitPaymentInfoLoading) {
          return; // Prevent duplicate submission
        }
    
        if (checkRequiredFields()) {
          console.log("there are missing filed");
          return;
        }
    
        if (checkIsAmountPaidEntered()) {
          return;
        }
        if (checkIsAmountPaid()) {
          return;
        }
        //return
        setIsSubmitPaymentInfoLoading(true); // Disable the submit button
        console.log("Order log:" , orderinfo);
        //return
        //const returnFromOrderInfo: IReturnFromOrderInfo = await onSubmitOrderInfo();
        //console.log("newOrderId:", returnFromOrderInfo.newOrderId);
        //console.log("receiptURL in payment:", returnFromOrderInfo.receiptURL);
        //const apiBody: any = orderInfo;
        //if (returnFromOrderInfo.newOrderId == -1) {
        //   alert("Error while creating order");
        //   return;
        // }
        // const apiBody: any = {
        //   ...orderInfo
        // };
        //const response = await OrderServices.createMembershipPayment(apiBody);
        const response = await OrderServices.updateMembershipOrder(orderinfo);
        console.log("createPayment response:", response);
        if (response.data != null) {
          if (response.data.hasErrors) {
            setIsSubmitPaymentInfoLoading(false);
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          // alert("Payment Posted successfully");
          alert("Order updated successfully");
          console.log("Payment response:", response);
          setPIModalOpen(false);
          setIsSubmitPaymentInfoLoading(false);
          //setViewInvoiceModalOpen(true);
          console.log("setViewInvoiceModalOpen is set to TRUE");
          // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
          // navigate("/member/findmember", { replace: true });
        } else {
          alert(response.data.errors);
          console.log("error");
          setIsSubmitPaymentInfoLoading(false);
        }
      }, 200);
  
      
    };

  const editOrder = async (data: any) => {
    console.log(data);
    
    /* if (!data.IsGuest) {
      console.log(
        "orderDetailItem:",
        data
      );
      setEditOrderOpen(true);
      if (data.OrderId) {
        getOrder(data.OrderId as number);
      }
    } else {
      console.log(
        "in guestOrderDetailItem:",
        data
      );
      setGuestOrderEventDetailModalOpen(true);
      if (
        data.OrderId &&
        data.IsGuest
      ) {
        getOrder(
          data.OrderId as number
        );
      }
    } */
  }

  const viewMember = async (data: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("members.view")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log(data);
    console.log(data.MemberShipOrder);
    // getMemberDetail(data.MemberId)
    console.log("getmemberdetail  clicked **************");
    const response = await EventServices.getMember(data.MemberId);
    console.log(response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      dispatch(assignCurrentMember(response.data.data[0]));
      navigate(routeConfig.MEMBER_DETAIL_URL, { replace: false });
      // navigate("/member", { replace: true });
      // dispatch(changeisNavigationFromEventToMember(true));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));

      // console.log(memberDetail)

      // setmemberDetail(response.data.data)
    } else {
      alert(response.data.errors[0]);
    }
  };

  const viewMyOrder = async (data: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("orders.view")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log(data);
    const encodedId = window.btoa(data.MemberId);
    navigate("/order?MemberId=" + encodedId, { replace: true });
    dispatch(changeCurrentMemberMenu(screenConfig.orderList));
  };

  const closeOrderDetail = () => {
    navigate("/order", { replace: false });
  };
  //   const orderClick = () => {
  //     if (currentOrderId !== null) {
  //         setEditOrderOpen(true);
  //         getOrder(currentOrderId);
  //     } else {
  //         // Handle the case where currentOrderId is null
  //     }
  // };

  const handleCancel = () => {
    setEditOrderOpen(false);
    setPIModalOpen(false);
  };

  const getOrder = async (OrderId: number) => {
    setOrderInfoSetFlag(false);
    const response = await OrderServices.getOrder(OrderId);
    console.log("OrderServices.getOrder:", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      //setOrderInfo(response.data.data);
      console.log("Success:", response.data.data);
      // setOrderInfo(response.data.data);

      // update order api slice
      if (
        response.data.data?.OrderId !== undefined ||
        response.data.data?.OrderId !== null
      ) {
        dispatch(
          storeUpdateOrder({
            key: "OrderId",
            value: response.data.data?.OrderId!,
          })
        );

        dispatch(
          storeUpdateOrder({
            key: "PaymentMethod",
            value: response.data.data?.PaymentMethod!,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "TransactionType",
            value: response.data.data?.TransactionType!,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: response.data.data?.CheckNumber!,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "LateFee",
            value: response.data.data?.LateFee!,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: response.data.data?.AuthCode!,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "PIComments",
            value: response.data.data?.PIComments!,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "NoInvoiceFlag",
            value: response.data.data?.NoInvoiceFlag!,
          })
        );
      }

      if (
        response.data.data?.MemberId !== undefined ||
        response.data.data?.MemberId !== null
      ) {
        dispatch(
          storeUpdateOrder({
            key: "MemberId",
            value: response.data.data?.MemberId!,
          })
        );
        console.log("participant List:", response.data.data?.MemberId!);
      }

      if (
        response.data.data?.TransactionType !== undefined ||
        response.data.data?.TransactionType !== null
      ) {
        dispatch(
          storeUpdateOrder({
            key: "TransactionType",
            value: response.data.data?.TransactionType!,
          })
        );
      }

      if (
        response.data.data?.CheckNumber !== undefined ||
        response.data.data?.CheckNumber !== null
      ) {
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: response.data.data?.CheckNumber!,
          })
        );
      }

      if (
        response.data.data?.LateFee !== undefined ||
        response.data.data?.LateFee !== null
      ) {
        dispatch(
          storeUpdateOrder({
            key: "LateFee",
            value: response.data.data?.LateFee!,
          })
        );
      }

      if (
        response.data.data?.AuthCode !== undefined ||
        response.data.data?.AuthCode !== null
      ) {
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: response.data.data?.AuthCode!,
          })
        );
      }

      if (
        response.data.data?.SeminarOrder &&
        response.data.data?.SeminarOrder.length > 0
      ) {
        console.log("storeAssignOrderItem CALLED SeminarOrder");
        dispatch(
          storeAssignOrderItem({
            key: "Orders",
            value: response.data.data?.SeminarOrder[0]!,
          })
        );
      } else if (
        response.data.data?.FunctionOrder &&
        response.data.data?.FunctionOrder.length > 0
      ) {
        console.log("storeAssignOrderItem CALLED FunctionOrder");
        dispatch(
          storeAssignOrderItem({
            key: "Orders",
            value: response.data.data?.FunctionOrder[0]!,
          })
        );
      }

      if (orderInfo.OrderType !== undefined || orderInfo.OrderType !== null) {
        dispatch(
          storeUpdateOrderItem({
            key: "OrderType",
            value: orderInfo.OrderType!,
          })
        );
      }

      if (
        response.data.data?.TransactionAmount !== undefined ||
        response.data.data?.TransactionAmount !== null
      ) {
        // setTransactionAmount(response.data.data?.TransactionAmount!);
        dispatch(
          storeUpdateOrder({
            key: "TransactionAmount",
            value: response.data.data?.TransactionAmount!,
          })
        );
      }

      if (dayjs(response.data.data?.DatePaid).isValid()) {
        dispatch(
          storeUpdateOrder({
            key: "DatePaid",
            value: dayjs(response.data.data?.DatePaid!, "YYYY-MM-DD").format(
              "YYYY-MM-DD"
            ),
          })
        );
        // setDatePaid(dayjs(response.data.data?.DatePaid!, "YYYY-MM-DD"));
      }
    } else {
      // Handle case where response data is null
    }
  };
   const [lateFee, setLateFee] = useState<number>(0);

   const updateOrderInfo = (updates: Partial<IOrderInfo>) => {
    setOrderInfo(prev => ({
      ...(prev || {} as IOrderInfo),
      ...updates
    }));
  };

  const updatePaymentInfo = (e: any, date?: Date | null) => {
      switch (e.target.name) {
        case "PaymentMethod":
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   PaymentMethod: e.target.value,
          // }));
          updateOrderInfo({
            TransactionType: e.target.value,
          });
          dispatch(
            storeUpdateOrder({
              key: "PaymentMethod",
              value: e.target.value,
            })
          );
        
          dispatch(
            storeUpdateOrder({
              key: "TransactionType",
              value: e.target.value,
            })
          );
          break;
  
        case "CouponAmount":
          updateOrderInfo({
            CouponAmount: e.target.value,
          });
              dispatch(
                storeUpdateOrder({
                  key: "CouponAmount",
                  value: e.target.value,
                })
              );
              /* updateOrderInfo({
                DueAmount: (totalAmount-(couponAmount + AmountPaid)),
              }); */
              dispatch(
                storeUpdateOrder({
                  key: "DueAmount",
                  value: (totalAmount-(couponAmount + AmountPaid)),
                })
              );
  
        break;
  
        case "DatePaid":
          // const formattedDate = date ? dayjs(date) : null;
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   DatePaid: formattedDate,
          // }));
          updateOrderInfo({
            DatePaid: e.target.value,
          });
          dispatch(
            storeUpdateOrder({
              key: "DatePaid",
              value: e.target.value,
            })
          );
  
          break;
  
        case "CheckNumber":
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   CheckNo: e.target.value,
          // }));
          updateOrderInfo({
            CheckNumber: e.target.value,
          });
          dispatch(
            storeUpdateOrder({
              key: "CheckNumber",
              value: e.target.value,
            })
          );
          break;
  
        case "AmountPaid":
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   AmountPaid: e.target.value,
          // }));
          updateOrderInfo({
            AmountPaid: e.target.value,
          });
          dispatch(
            storeUpdateOrder({
              key: "AmountPaid",
              value: e.target.value,
            })
          );
          /* updateOrderInfo({
            DueAmount: (totalAmount-(couponAmount + AmountPaid)),
          }); */
          dispatch(
            storeUpdateOrder({
              key: "DueAmount",
              value: (totalAmount-(couponAmount + AmountPaid)),
            })
          );
          break;
  
        case "LateFee":
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   LateFee: e.target.value,
          // }));
          updateOrderInfo({
            LateFee: e.target.value,
          });
          dispatch(
            storeUpdateOrder({
              key: "LateFee",
              value: e.target.value,
            })
          );
          break;
  
        case "AuthCode":
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   AuthCode: e.target.value,
          // }));
          updateOrderInfo({
            AuthCode: e.target.value,
          });
          dispatch(
            storeUpdateOrder({
              key: "AuthCode",
              value: e.target.value,
            })
          );
          break;
  
        case "Comments":
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   PIComments: e.target.value,
          // }));
          updateOrderInfo({
            Comments: e.target.value,
          });
          dispatch(
            storeUpdateOrder({
              key: "Comments",
              value: e.target.value,
            })
          );
          break;
  
        case "NoInvoiceFlag":
          // setPaymentInfo((prevValues) => ({
          //   ...prevValues,
          //   NoInvoiceFlag: false,
          // }));
          updateOrderInfo({
            NoInvoice: e.target.checked,
          });
          dispatch(
            storeUpdateOrder({
              key: "NoInvoice",
              value: e.target.checked,
            })
          );
          break;
  
        default:
          console.log("default");
          break;
      }
    };

  const callUpdateOrderAPI = async () => {
    // alert("callUpdateOrderAPI");
    if (orderInfoSetFlag === true) {
      console.log("onSUBMIT:", orderInfo);
      const apiBody: any = orderInfo;
      const response = await OrderServices.updateOrder(apiBody);
      dispatch(storeResetGuestOrder());
      setEditOrderOpen(false);
      console.log("OrderServices.updateOrder-response", response);
      // alert("response received");
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        alert("Order Updated successfully");
        setEditOrderOpen(false);

        dispatch(
          storeUpdateOrder({
            key: "TransactionAmount",
            value: 0,
          })
        );
      } else {
        alert(response.data.errors);
        console.log("error");
      }
    }
  };
  return (
    <>
      {/* personal info */}
      <div
        className="dashboard-content-wrapper"
        style={{ marginBottom: "100px" }}
      >
        {/* member info */}

        <div className="horizontal-wrapper-spacebetween align-items-center my-1">
          <h1 className="page-heading">View Order</h1>
          <div className="d-flex ">
            <SecondaryWhiteButton
              className="button-wrapper me-3"
              type="submit"
              onClick={() => viewMyOrder(orderinfo)}
            >
              <span style={{ fontWeight: "500" }}>View My Orders</span>
            </SecondaryWhiteButton>
            <SecondaryWhiteButton
              className="button-wrapper"
              type="submit"
              onClick={() => viewMember(orderinfo)}
            >
              <span style={{ fontWeight: "500" }}>View Profile</span>
            </SecondaryWhiteButton>
          </div>
        </div>
        {/* <div className="d-flex justify-content-between">
          <div className="section-box-detail col-3">
            <span className="section-heading">Date:</span>
            {typeof orderinfo?.CreatedAt === 'string'
              ? moment(orderinfo.CreatedAt).local().format("YYYY-MM-DD HH:mm A")
              : "N/A"
            }
          </div>
          <div className="section-box-detail col-2">
            <span className="section-heading">Order Id:</span>{orderinfo?.Id}</div>
          <div className="section-box-detail col-3">
            <span className="section-heading">Created By:</span>{orderinfo?.TransactionDoneByName}
          </div>
        </div> */}

        <div className="section-box-detail ">
          <div className="horizontal-wrapper-spacebetween">
            <h3 className="section-heading">Order Details</h3>
            { orderinfo && orderinfo?.MemberShipOrder.length > 0 && (
              <SecondaryWhiteButton
                className="button-wrapper me-3"
                type="submit"
                // onClick={() => setEditOrderOpen(true)}
                onClick={() => {
                  setPIModalOpen(true);
                  
                  if (orderinfo?.OrderId) {
                    getOrder(orderinfo?.OrderId as number);
                  } else {
                    console.error("Order ID is not available");
                  }
                }}
              >
                <span style={{ fontWeight: "500" }}>Edit Order</span>
              </SecondaryWhiteButton>
            )}
          </div>

          {isLoading ? (
            <div className="form-wrapper-smaller-grid d-flex flex-wrap justify-content-between">
              <span>Loading...</span>
            </div>
          ) : (
            <div className="form-wrapper-smaller-grid d-flex flex-wrap justify-content-between">
              <div className="col-4 my-2">
                <span className="section-heading">Transaction Date: </span>
                {typeof orderinfo?.CreatedAt === "string"
                  ? moment(orderinfo.CreatedAt)
                      .local()
                      .format("MM-DD-YYYY HH:mm A")
                  : "N/A"}
              </div>
              <div className="col-3 my-2">
                <span className="section-heading">Order ID: </span>
                {orderinfo?.OrderId}
              </div>
              <div className="col-3 my-2">
                <span className="section-heading">Order Type: </span>
                {orderinfo && orderinfo?.SeminarOrder.length > 0
                  ? " Seminar"
                  : orderinfo && orderinfo?.FunctionOrder.length > 0
                  ? " Function"
                  : orderinfo && orderinfo?.VideoOrder.length > 0
                  ? " Video"
                  : orderinfo && orderinfo?.MemberShipOrder.length > 0
                  ? " Membership"
                  : " - "}
              </div>
              <div className="col-4 my-2">
                <span className="section-heading">Transaction Type: </span>
                {orderinfo?.TransactionType ? orderinfo?.TransactionType : " -"}
              </div>
              <div className="col-3 my-2">
                <span className="section-heading">Transaction Amount: $</span>
                {orderinfo?.AmountPaid ? orderinfo?.AmountPaid : "0.00"}
              </div>
              <div className="col-3 my-2">
                <span className="section-heading">Late Fee: </span>
                {orderinfo?.LateFee ? orderinfo?.LateFee : " 0"}
              </div>
              <div className="col-4 my-2">
                <span className="section-heading">Check Number: </span>
                {orderinfo?.CheckNumber ? orderinfo?.CheckNumber : " N/A"}
              </div>
              <div className="col-3 my-2">
                <span className="section-heading">Auth Code: </span>
                {orderinfo?.AuthCode ? orderinfo?.AuthCode : " N/A"}
              </div>
              <div className="col-3 my-2">
                <span className="section-heading">Date Paid: </span>
                {typeof orderinfo?.DatePaid === "string"
                  ? moment(orderinfo.DatePaid).local().format("MM-DD-YYYY")
                  : " N/A"}
              </div>
              <div className="col-3 my-2">
                <span className="section-heading">Discount Amount: </span>
                {orderinfo?.CouponAmount ? orderinfo?.CouponAmount : " N/A"}
              </div>
              <div className="col-7 my-2">
                <span className="section-heading">Notes: </span>
                {orderinfo?.Comments ? orderinfo?.Comments : " N/A"}
              </div>
            </div>
          )}
        </div>

        {/* <div className="order-details-container d-flex justify-content-between">
          <div className="order-detail ms-4">
            <span className="detail-label">Date:</span>
            <span className="detail-value">
            {typeof orderinfo?.CreatedAt === 'string'
              ? moment(orderinfo.CreatedAt).local().format("YYYY-MM-DD HH:mm A")
              : "N/A"
            }
            </span>
          </div>
          <div className="order-detail">
            <span className="detail-label">Order Id:</span>
            <span className="detail-value">{ orderinfo?.Id}</span>
          </div>
          <div className="order-detail me-4">
            <span className="detail-label">Created By:</span>
            <span className="detail-value">{orderinfo?.TransactionDoneByName}</span>
          </div>
        </div> */}

        {/* <div className="d-flex justify-content-between">
          <div className="section-box-detail-nav ms-3 col-3">
            <span className="section-heading">Date:</span>
            {typeof orderinfo?.CreatedAt === 'string'
              ? moment(orderinfo.CreatedAt).local().format("YYYY-MM-DD HH:mm A")
              : "N/A"
            }
          </div>
          <div className="section-box-detail-nav col-2">
            <span className="section-heading">Order Id:</span>{orderinfo?.Id}</div>
          <div className="section-box-detail-nav col-3 ms-3">
            <span className="section-heading">Created By:</span>
          </div>
        </div> */}

        <div className="section-box">
          <div className="horizontal-wrapper-spacebetween">
            <h3 className="section-heading">Personal Information</h3>
          </div>
          {isLoading ? (
            <div className="form-wrapper-smaller-grid d-flex flex-wrap justify-content-between">
              <span>Loading...</span>
            </div>
          ) : (
            <div className="form-wrapper-smaller-grid">
              {/* line 1 */}
              <div className="input-field-div-wrapper-smaller-griditem">
                <input
                  className="input-field-div-small"
                  id="FirstName"
                  name="FirstName"
                  disabled={true}
                  // value={orderinfo.FirstName}
                  value={
                    typeof orderinfo != "undefined" || orderinfo != null
                      ? (orderinfo.FirstName as string)
                      : ("" as string)
                  }
                />
                <label className="form-label" htmlFor="FirstName">
                  First Name
                </label>
              </div>
              <div className="input-field-div-wrapper-smaller-griditem">
                <input
                  className="input-field-div-small"
                  id="LastName"
                  name="LastName"
                  disabled={true}
                  // value={orderinfo.LastName}
                  value={
                    typeof orderinfo != "undefined" || orderinfo != null
                      ? (orderinfo.LastName as string)
                      : ("" as string)
                  }
                />
                <label className="form-label" htmlFor="LastName">
                  Last Name
                </label>
              </div>
              <div className="input-field-div-wrapper-smaller-griditem">
                <input
                  className="input-field-div-small"
                  id="BarId"
                  name="BarId"
                  disabled={true}
                  // value={orderinfo.BarId}
                  value={
                    typeof orderinfo != "undefined" || orderinfo != null
                      ? (orderinfo.BarId as string)
                      : ("" as string)
                  }
                />
                <label className="form-label" htmlFor="BarId">
                  Bar ID
                </label>
              </div>
              <div className="input-field-div-wrapper-smaller-griditem">
                <input
                  className="input-field-div-small"
                  id="MemberCode"
                  name="MemberCode"
                  disabled={true}
                  // value={
                  //   orderinfo.MemberCode + "-" + orderinfo.memberCodeDescription!
                  // }
                  value={
                    orderinfo && orderinfo.MemberCode
                      ? ((orderinfo.MemberCode +
                          "-" +
                          orderinfo.MemberCodeDescription!) as string)
                      : ("" as string)
                  }
                />
                <label className="form-label" htmlFor="LastName">
                  Member Code
                </label>
              </div>

              {/* line 2 */}

              <div className="input-field-div-wrapper-smaller-griditem">
                <input
                  className="input-field-div-small"
                  id="FirmName"
                  name="FirmName"
                  disabled={true}
                  // value={"Firm name missing"}
                  value={
                    typeof orderinfo != "undefined" || orderinfo != null
                      ? (orderinfo.FirmName as string)
                      : ("" as string)
                  }
                />
                <label className="form-label" htmlFor="FirmName">
                  Firm Name
                </label>
              </div>
              <div className="input-field-div-wrapper-smaller-griditem">
                <input
                  className="input-field-div-small"
                  id="PhoneNumber"
                  name="PhoneNumber"
                  disabled={true}
                  // value={orderinfo.PhoneNumber}
                  value={
                    typeof orderinfo != "undefined" || orderinfo != null
                      ? formatPhoneNumber(orderinfo.PhoneNumber)
                      : ("" as string)
                  }
                />
                <label className="form-label" htmlFor="PhoneNumber">
                  Phone Number
                </label>
              </div>
              <div className="input-field-div-wrapper-smaller-griditem">
                <input
                  className="input-field-div-small"
                  id="Email"
                  name="Email"
                  disabled={true}
                  // value={orderinfo.Email}
                  value={
                    typeof orderinfo != "undefined" || orderinfo != null
                      ? (orderinfo.Email as string)
                      : ("" as string)
                  }
                />
                <label className="form-label" htmlFor="Email">
                  Email ID
                </label>
              </div>
              {/* line 3 */}
              <div className="input-field-div-wrapper-large-griditem">
                <input
                  className="input-field-div-small"
                  id="Address"
                  name="Address"
                  disabled={true}
                  value={address.join("")}
                  //   orderinfo
                  //     ? (orderinfo.Address1 ? orderinfo.Address1 + ", " : "") +
                  //       (orderinfo.Address2 ? orderinfo.Address2 + ", " : "") +
                  //       (orderinfo.County ? orderinfo.County + ", " : "") +
                  //       (orderinfo.State ? orderinfo.State : "")
                  //     : ""
                  // }
                />
                <label className="form-label" htmlFor="Address">
                  Address
                </label>
              </div>
            </div>
          )}
        </div>

        {/* Seminar loop */}
        {typeof orderinfo != "undefined" || orderinfo != null ? (
          orderinfo.SeminarOrder.map((seminar) => (
            <div className="section-box">
              <div className="horizontal-wrapper-spacebetween">
                <div className="horizontal-wrapper-spacebetween">
                  <h3 className="section-heading">Seminar</h3>
                </div>
                <div
                  className="horizontal-wrapper-spacebetween"
                  style={{ width: "60%" }}
                >
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="EventName"
                      name="EventName"
                      disabled={true}
                      value={
                        typeof orderinfo != "undefined" || orderinfo != null
                          ? (orderinfo.SeminarOrder[0].EventName! as string)
                          : ("" as string)
                      }
                    />
                    <label className="form-label" htmlFor="EventName">
                      Event Name
                    </label>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="EventId"
                      name="EventId"
                      disabled={true}
                      // value={eventInfo.UniqueEventId as string}
                      value={
                        typeof orderinfo != "undefined" || orderinfo != null
                          ? (orderinfo.SeminarOrder[0].UniqueEventId! as string)
                          : ""
                      }
                    />
                    <label className="form-label" htmlFor="EventName">
                      Event ID
                    </label>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <ThemeProvider theme={muiDatePickerColorTheme}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          className="datepicker-local"
                          label="Start Date"
                          // value={StartDateTime}
                          disabled={true}
                          // value={dayjs(eventInfo.StartDateTime)}
                          value={dayjs(
                            typeof orderinfo != "undefined" || orderinfo != null
                              ? (orderinfo.SeminarOrder[0]
                                  .StartDateTime! as string)
                              : ("" as string)
                          )}
                        />
                      </LocalizationProvider>
                    </ThemeProvider>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <ThemeProvider theme={muiDatePickerColorTheme}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          className="datepicker-local"
                          label="End Date"
                          // value={StartDateTime}
                          disabled={true}
                          // value={dayjs(eventInfo.EndDateTime)}
                          value={dayjs(
                            typeof orderinfo != "undefined" || orderinfo != null
                              ? (orderinfo.SeminarOrder[0]
                                  .EndDateTime! as string)
                              : ("" as string)
                          )}
                        />
                      </LocalizationProvider>
                    </ThemeProvider>
                  </div>
                  <div
                    className="input-field-div-wrapper-largest"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <input
                      className="input-field-div-small"
                      id="EventDesc"
                      name="EventDesc"
                      disabled={true}
                      // value={eventInfo.Description as string}
                      value={
                        typeof orderinfo != "undefined" || orderinfo != null
                          ? (orderinfo.SeminarOrder[0].Description! as string)
                          : ("" as string)
                      }
                    />
                    <label
                      className="form-label"
                      htmlFor="EventDesc"
                      style={{ marginTop: "3px" }}
                    >
                      Event Description
                    </label>
                  </div>
                </div>
                <div
                  className="order-summary"
                  style={{ width: "35%", height: "auto" }}
                >
                  {/* Order summary */}
                  <h5 className="order-header">Cost</h5>
                  <div className="order-items">
                    {/* Cost */}
                    {orderinfo &&
                    orderinfo.SeminarOrder &&
                    orderinfo.SeminarOrder.length > 0 ? (
                      orderinfo.SeminarOrder[0].Costs.map((costItem) => (
                        <div
                          key={costItem.CostId}
                          className="horizontal-wrapper-rightaligned"
                        >
                          <label className="orderitem-label">
                            {costItem.CostName}
                          </label>
                          <label
                            style={{ width: "10%", paddingLeft: "0.5rem" }}
                          >
                            :
                          </label>
                          <span className="orderitem-value">
                            {Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(costItem.Cost as number)}
                          </span>
                        </div>
                      ))
                    ) : (
                      <></>
                    )}
                  </div>
                  <h5 className="order-header">Location</h5>
                  <div className="order-items">
                    {/* Location */}
                    {typeof orderinfo &&
                    orderinfo.SeminarOrder &&
                    orderinfo.SeminarOrder.length > 0 &&
                    orderinfo.SeminarOrder[0].Location ? (
                      // orderinfo.SeminarOrder[0].Location.map((LocationItem) =>
                      <div
                        key={orderinfo.SeminarOrder[0].Location.Id}
                        className="horizontal-wrapper-leftaligned"
                      >
                        <label className="orderitem-label">
                          {orderinfo.SeminarOrder[0].Location.Location}
                        </label>
                        {/* <label style={{ width: "10%", paddingLeft: "0.5rem" }}>
                          :
                        </label>
                        <span className="orderitem-value">
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(
                            orderinfo.SeminarOrder[0].Location.Cost as number
                          )}
                        </span> */}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}

        {/* Funtions */}
        {orderinfo &&
        orderinfo.FunctionOrder &&
        orderinfo.FunctionOrder.length > 0 ? (
          orderinfo.FunctionOrder.map((func) => (
            <div className="section-box">
              <div className="horizontal-wrapper-spacebetween">
                <div className="horizontal-wrapper-spacebetween">
                  <h3 className="section-heading">Function</h3>
                </div>
                <div
                  className="horizontal-wrapper-spacebetween"
                  style={{ width: "60%" }}
                >
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="EventName"
                      name="EventName"
                      disabled={true}
                      value={
                        typeof orderinfo != "undefined" || orderinfo != null
                          ? (orderinfo.FunctionOrder[0].EventName! as string)
                          : ("" as string)
                      }
                    />
                    <label className="form-label" htmlFor="EventName">
                      Event Name
                    </label>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <input
                      className="input-field-div-small"
                      id="EventId"
                      name="EventId"
                      disabled={true}
                      // value={eventInfo.UniqueEventId as string}
                      value={
                        typeof orderinfo != "undefined" || orderinfo != null
                          ? (orderinfo.FunctionOrder[0]
                              .UniqueEventId! as string)
                          : ""
                      }
                    />
                    <label className="form-label" htmlFor="EventName">
                      Event ID
                    </label>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <ThemeProvider theme={muiDatePickerColorTheme}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          className="datepicker-local"
                          label="Start Date"
                          // value={StartDateTime}
                          disabled={true}
                          // value={dayjs(eventInfo.StartDateTime)}
                          value={dayjs(
                            typeof orderinfo != "undefined" || orderinfo != null
                              ? (orderinfo.FunctionOrder[0]
                                  .StartDateTime! as string)
                              : ("" as string)
                          )}
                        />
                      </LocalizationProvider>
                    </ThemeProvider>
                  </div>
                  <div className="input-field-div-wrapper-small">
                    <ThemeProvider theme={muiDatePickerColorTheme}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          className="datepicker-local"
                          label="End Date"
                          // value={StartDateTime}
                          disabled={true}
                          // value={dayjs(eventInfo.EndDateTime)}
                          value={dayjs(
                            typeof orderinfo != "undefined" || orderinfo != null
                              ? (orderinfo.FunctionOrder[0]
                                  .EndDateTime! as string)
                              : ("" as string)
                          )}
                        />
                      </LocalizationProvider>
                    </ThemeProvider>
                  </div>
                  <div
                    className="input-field-div-wrapper-largest"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <input
                      className="input-field-div-small"
                      id="EventDesc"
                      name="EventDesc"
                      disabled={true}
                      // value={eventInfo.Description as string}
                      value={
                        typeof orderinfo != "undefined" || orderinfo != null
                          ? (orderinfo.FunctionOrder[0].Description! as string)
                          : ("" as string)
                      }
                    />
                    <label
                      className="form-label"
                      htmlFor="EventDesc"
                      style={{ marginTop: "3px" }}
                    >
                      Event Description
                    </label>
                  </div>
                </div>
                <div
                  className="order-summary"
                  style={{ width: "35%", height: "auto" }}
                >
                  {/* Order summary */}
                  <h5 className="order-header">Cost</h5>
                  <div className="order-items">
                    {/* Cost */}
                    {typeof orderinfo != "undefined" || orderinfo != null ? (
                      orderinfo.FunctionOrder[0].Costs &&
                      orderinfo.FunctionOrder[0].Costs.map((costItem) => (
                        <div
                          key={costItem.CostId}
                          className="horizontal-wrapper-rightaligned"
                        >
                          <label className="orderitem-label">
                            {costItem.CostName}
                          </label>
                          <label
                            style={{ width: "10%", paddingLeft: "0.5rem" }}
                          >
                            :
                          </label>
                          <span className="orderitem-value">
                            {Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(costItem.Cost as number)}
                          </span>
                        </div>
                      ))
                    ) : (
                      <></>
                    )}
                  </div>
                  <h5 className="order-header">Location</h5>
                  <div className="order-items">
                    {/* Location */}
                    {orderinfo &&
                    orderinfo.FunctionOrder &&
                    orderinfo.FunctionOrder.length > 0 &&
                    orderinfo.FunctionOrder[0].Location ? (
                      // orderinfo.FunctionOrder[0].Location.map(
                      // (LocationItem) => (
                      <div
                        key={orderinfo.FunctionOrder[0].Location.LocationId}
                        className="horizontal-wrapper-leftaligned"
                      >
                        <label className="orderitem-label">
                          {orderinfo.FunctionOrder[0].Location.Location}
                        </label>
                        {/* <label style={{ width: "10%", paddingLeft: "0.5rem" }}>
                          :
                        </label>
                        <span className="orderitem-value">
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(
                            orderinfo.FunctionOrder[0].Location.Cost as number
                          )}
                        </span> */}
                      </div>
                    ) : (
                      // )
                      // )
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}

        {/* membership & Video */}

        {/* Video */}
        {orderinfo &&
          orderinfo.VideoOrder &&
          orderinfo?.VideoOrder.length > 0 && (
            <div
              className="horizontal-wrapper-spacebetween"
              style={{ width: "50%" }}
            >
              <div className="horizontal-wrapper-spacebetween">
                <h3 className="section-heading">Videos</h3>
              </div>
              <div
                className="order-summary"
                style={{ width: "80%", height: "auto" }}
              >
                {/* Order summary */}
                <h5 className="order-header">Orders</h5>
                <div className="order-items">
                  {orderinfo?.VideoOrder.map((VideoOrderItem) => (
                    <div
                      key={VideoOrderItem.Id}
                      className="horizontal-wrapper-rightaligned"
                    >
                      <label className="orderitem-label">
                        {VideoOrderItem.EventName}
                      </label>
                      <label
                        style={{
                          width: "10%",
                          paddingLeft: "0.5rem",
                        }}
                      >
                        :
                      </label>
                      <span className="orderitem-value">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(
                          VideoOrderItem.VideoCost
                            ? (VideoOrderItem.VideoCost[0].Cost as number)
                            : 0
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

        {/* membership */}
        {orderinfo &&
          orderinfo?.MemberShipOrder &&
          orderinfo?.MemberShipOrder.length > 0 && (
            <div
              className="horizontal-wrapper-spacebetween"
              style={{ width: "50%" }}
            >
              <div className="horizontal-wrapper-spacebetween">
                <h3 className="section-heading">Membership Sections</h3>
              </div>
              <div
                className="order-summary"
                style={{ width: "80%", height: "auto" }}
              >
                {/* Order summary */}
                <h5 className="order-header">Orders</h5>
                <div className="order-items">
                  {orderinfo?.MemberShipOrder.map((MemberShipOrderItem) => (
                    <div
                      key={MemberShipOrderItem.Id}
                      className="horizontal-wrapper-rightaligned"
                    >
                      <label className="orderitem-label">
                        {MemberShipOrderItem.Description}
                      </label>
                      <label
                        style={{
                          width: "10%",
                          paddingLeft: "0.5rem",
                        }}
                      >
                        :
                      </label>
                      <span className="orderitem-value">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(MemberShipOrderItem.Fee as number)}
                      </span>
                    </div>
                  ))}
                  {orderinfo?.SectionOrder.map((sectionItem) => (
                    <div
                      key={sectionItem.Id}
                      className="horizontal-wrapper-rightaligned"
                    >
                      <label className="orderitem-label">
                        {sectionItem.SectionName}
                      </label>
                      <label
                        style={{
                          width: "10%",
                          paddingLeft: "0.5rem",
                        }}
                      >
                        :
                      </label>
                      <span className="orderitem-value">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(sectionItem.Fee as number)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

        {/* total amount */}
        {/* <div className="horizontal-wrapper-rightaligned">
          <div
            style={{
              width: "18%",
              color: "#000000",
              fontWeight: "500",
            }}
          >
            <span className="orderitem-label"> TOTAL AMOUNT </span>
            <label style={{ width: "10%", paddingLeft: "0.5rem" }}>:</label>
            <span className="orderitem-value">
              {Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(
                typeof orderinfo != "undefined" || orderinfo != null
                  ? (orderinfo.TransactionAmount as number)
                  : 0
              )}
            </span>
          </div>
        </div> */}
      </div>
      {/* ----------Submit button Information------------ */}
      <div className="submit-floating-button-div">
        <Button
          className="submit-button-div"
          type="submit"
          onClick={() => {
            // onSubmit();
            closeOrderDetail();
          }}
        >
          Close
        </Button>
      </div>
      <ReactModal
              isOpen={PIModalOpen}
              onRequestClose={() => {
                setPIModalOpen(false);
              }}
              className="editinfo-modal-medium"
              overlayClassName="overlay"
            >
              <div className="horizontal-wrapper-spacebetween">
                <h1 className="page-heading">Update Pay Information</h1>
                <PageLink onClick={handleCancel}>Cancel</PageLink>
              </div>
              <form
                className="form-wrapper"
                onSubmit={handleSubmitPI(onSubmitPaymentInfo)}
                noValidate
              >
                {/* <div className="input-field-div-wrapper">
                        <input
                          className="input-field-div-small"
                          id="PaymentMethod"
                          name="PaymentMethod"
                          placeholder=""
                          onChange={(e) => {
                            updatePaymentInfo(e);
                          }}
                          disabled={false}
                          autoComplete="off"
                        />
                        <label className="form-label" htmlFor="PaymentMethod">
                          Payment Method
                        </label>
                      </div> */}
      
                <div className="input-field-div-wrapper">
                  <select
                    className="dropdown-control-large-insidetextfield"
                    name="PaymentMethod"
                    value={orderinfo?.TransactionType?.toString() || ""}
                    onChange={(e) => {
                      updatePaymentInfo(e);
                      setTransactionType(e.target.value);
                    }}
                  >
                    <option value={""}> Select Payment Type </option>
                    <option value="American Express">American Express</option>
                    <option value="Authorize.net">Authorize.net</option>
                    <option value="Check">Check</option>
                    <option value="Discover">Discover</option>
                    <option value="MasterCard">MasterCard</option>
                    <option value="Visa">Visa</option>
                    <option value="Website">Website</option>
                  </select>
                </div>
      
                <div style={{ width: "28%", marginBottom: "1.8rem" }}>
                  <Controller
                    control={controlPI}
                    name="DatePaid"
                    // rules={{ required: "* required field" }}
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                      fieldState: { error },
                    }) => (
                      <ThemeProvider theme={muiDatePickerColorTheme}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="datepicker-local"
                            label="Date Paid"
                            value={orderinfo?.DatePaid ? dayjs(orderinfo?.DatePaid.toString()) : null}
                            onChange={(date: Dayjs | null) => {
                              const formattedDate = date
                                ? dayjs(date).format("YYYY-MM-DD")
                                : null;
                              const syntheticEvent = {
                                target: {
                                  name: "DatePaid",
                                  value: date
                                    ? dayjs(date).format("YYYY-MM-DD")
                                    : null,
                                },
                              };
                              updateOrderInfo({
                                DatePaid: formattedDate,
                              });
                              dispatch(
                                storeUpdateOrder({
                                  key: "DatePaid",
                                  value: formattedDate,
                                })
                              );
                              setDatePaid(date);
                              updatePaymentInfo(syntheticEvent, date?.toDate());
                              date && setDatePaid(dayjs(date));
                            }}
                          />
                        </LocalizationProvider>
                      </ThemeProvider>
                    )}
                  />
                </div>
      
                <div className="input-field-div-wrapper">
                  <input
                    className="input-field-div-small"
                    id="CheckNumber"
                    name="CheckNumber"
                    value={orderinfo?.CheckNumber?.toString() || ""}
                    placeholder=""
                    onChange={(e) => {
                      updatePaymentInfo(e);
                    }}
                    disabled={false}
                    autoComplete="off"
                  />
                  <label className="form-label" htmlFor="CheckNumber">
                    Check Number
                  </label>
                </div>
                <div className="input-field-div-wrapper">
                  <input
                    className="input-field-div-small"
                    id="AmountPaid"
                    name="AmountPaid"
                    pattern="0-9"
                    placeholder=""
                    onChange={(e) => {
                      updatePaymentInfo(e);
                    }}
                    value={orderinfo?.AmountPaid?.toString() || ""}
                    // disabled={true}
                    autoComplete="off"
                  />
                  <label className="form-label" htmlFor="AmountPaid">
                    Amount Paid
                  </label>
                </div>
      
                <div className="input-field-div-wrapper">
                  <input
                    className="input-field-div-small"
                    id="LateFee"
                    name="LateFee"
                    placeholder=""
                    value={orderinfo?.LateFee?.toString() || ""}
                    pattern="[0-9]*"
                    onChange={(e) => {
                      updatePaymentInfo(e);
                    }}
                    disabled={false}
                    autoComplete="off"
                  />
                  <label className="form-label" htmlFor="LateFee">
                    Late Fee
                  </label>
                </div>
      
                <div className="input-field-div-wrapper">
                  <input
                    className="input-field-div-small"
                    id="AuthCode"
                    name="AuthCode"
                    placeholder=""
                    value={orderinfo?.AuthCode?.toString() || ""}
                    onChange={(e) => {
                      updatePaymentInfo(e);
                    }}
                    disabled={false}
                    autoComplete="off"
                  />
                  <label className="form-label" htmlFor="AuthCode">
                    Auth Code
                  </label>
                </div>
      
                <div
                  className="input-field-div-wrapper"
                  style={{ marginTop: "2rem" }}
                >
                  <input
                    className="input-field-div-small"
                    id="CouponAmount"
                    name="CouponAmount"
                    pattern="[0-9]*"
                    placeholder=""
                    value={orderinfo?.CouponAmount?.toString() || ""}
                    onChange={(e) => {
                      const amount = parseInt(e.target.value) || 0;
                      setCouponAmount(amount);
                      updatePaymentInfo(e);
                    }}
                    disabled={false}
                    autoComplete="off"
                  />
                  <label className="form-label" htmlFor="CouponAmount">
                    Discount Amount
                  </label>
                </div>
      
                <div
                  className="input-field-div-wrapper"
                  style={{ marginTop: "2rem" }}
                >
                  <input
                    className="input-field-div-small"
                    id="TotalAmount"
                    name="TotalAmount"
                    pattern="[0-9]*"
                    placeholder=""
                    value={orderinfo?.TotalAmount?.toString() || ""}
                    disabled={true}
                    autoComplete="off"
                  />
                  <label className="form-label" htmlFor="TotalAmount">
                    Total Amount
                  </label>
                </div>
      
                <div className="textarea-wrapper" style={{ width: "28%" }}>
                  <TextField
                    className="textarea"
                    id="Comments"
                    name="Comments"
                    placeholder="Comments"
                    multiline
                    value={orderinfo?.Comments}
                    rows={3}
                    onChange={(e) => {
                      updatePaymentInfo(e);
                    }}
                  />
                  {/* <label className="form-label" htmlFor="PIcomments">
                          Comments
                        </label> */}
                </div>
      
                {/* <div className="order-checkboxgroup">
                        <input
                          id="NoInvoiceFlag"
                          name="NoInvoiceFlag"
                          className="checkbox"
                          type="checkbox"
                          onChange={(e) => updatePaymentInfo(e)}
                        />
                        <div>
                          <span> No Invoice</span>
                        </div>
                      </div> */}
      
                <div className="horizontal-wrapper-centeralign">
                  <div className="submit-button-div ">
                    <Button
                      type="submit"
                      // onClick={onSubmit}
                    >
                      {isSubmitPaymentInfoLoading ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                </div>
              </form>
            </ReactModal>
      <ReactModal
        isOpen={addEditOrderOpen}
        onRequestClose={() => setEditOrderOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Update Cost and Payment Information</h1>
          <PageLink onClick={() => handleCancel()}>Close</PageLink>
        </div>
        {orderInfoSetFlag === true ? (
          <EventMemberPaymentInfo
            callOrderAPI={callUpdateOrderAPI}
            closeModal={() => setEditOrderOpen(false)}
          />
        ) : (
          <h3>Loading...</h3>
        )}
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default ViewOrder;
